module["exports"] = [
  "#{city_prefix}"
];
